import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useFormikContext } from "formik";
import { MapPin } from "lucide-react";
import moment from "moment";
import AddButton from "../../../components/buttons/button";
import SelectField from "../../../components/forms/select-field";
import AddressSidebarSales from "../../../components/common-components/address-bar-sales";
import StarIcon from "../../../assets/icons/req-star";
import { userTableAction } from "../../../redux/actions/user-action";
import DocumentTrays from "../../../components/common-components/document-trays";

const name = "pl";

const PickListNavbar = ({
  isClone = false,
  pageType,
  page = "",
  disabled = false,
  transfer = false,
  standAlone = true,
  storeDetails = {},
  pickListId,
  trays,
  canEditTrays = false,
}) => {
  const dispatch = useDispatch();
  const { values, setFieldValue } = useFormikContext();
  const [addressPanel, setAddressPanel] = useState(false);
  const [userOptions, setUserOptions] = useState([]);

  useEffect(() => {
    dispatch(
      userTableAction(
        {
          module: "picklist",
          pageNumber: 1,
          pageSize: 100,
          filterData: {
            sort_by: "",
            sort_order: "",
            selectColumn: "",
            from: "",
            to: "",
            inputValue: "",
            role: "",
          },
        },
        (data) => {
          const options = (data?.data?.userList || []).map((user) => ({
            label: user?.user_name,
            value: user?.user_id,
          }));
          setUserOptions(options);
        },
        () => {}
      )
    );
  }, []);

  const fieldLabelClass =
    "min-h-[1.2rem] text-[var(--search-input-label-color)] text-[length:var(--search-label-font-size)] font-[var(--search-label-font-weight)]";
  const fieldInputClass =
    "min-h-[40px] px-2 flex items-center border border-[var(--search-input-border)] bg-[var(--toggle-disabled-background)] text-[var(--search-input-color)] text-[length:var(--search-input-font-size)] font-[var(--search-input-font-weight)] border-radius";

  const ReadOnlyField = ({ label, value }) => (
    <div className="flex flex-col">
      <label className={fieldLabelClass}>{label}</label>
      <div className={fieldInputClass}>{value || "-"}</div>
    </div>
  );

  return (
    <div className="flex flex-col">
      <AddressSidebarSales
        isClone={isClone}
        clickedplus={false}
        pageType={pageType}
        open={addressPanel}
        setOpen={setAddressPanel}
        id={values?.cmr_id}
        pos_id={values?.pos_id}
        name={name}
        page={page}
        disabled={true}
        storeState={storeDetails?.store_state}
        transfer={transfer}
        standAlone={standAlone}
      />

      <div className="mt-4 w-full">
        <h3 className="mb-2 text-[var(--input-label-color)] font-bold text-[0.95rem] whitespace-nowrap">
          Customer And Pick List Information
        </h3>

        <div className="bg-[var(--add-billing-head-bg)] border-radius w-full p-4">
          <div className="flex flex-nowrap items-end gap-4 overflow-x-auto">
            <div className="flex-1 min-w-[160px]">
              <ReadOnlyField label="Customer Code" value={values?.cmr_code?.label} />
            </div>
            <div className="flex-1 min-w-[160px]">
              <ReadOnlyField label="Customer Name" value={values?.cmr_name?.label} />
            </div>
            <div className="flex-1 min-w-[160px]">
              <ReadOnlyField
                label="Order Date"
                value={
                  values?.pl_order_date
                    ? moment(values.pl_order_date, ["DD/MM/YYYY", moment.ISO_8601]).format(
                        "DD MMM YYYY"
                      )
                    : ""
                }
              />
            </div>
            <div className="shrink-0">
              <AddButton
                icon={<MapPin size={13} />}
                text={
                  <span className="flex items-center gap-1">
                    Address Details
                    <StarIcon />
                  </span>
                }
                className={`flex items-center px-[12px] h-[44px] whitespace-nowrap rounded-[8px] gap-[8px] bg-[var(--general-button-bg)] cursor-pointer border border-[var(--general-button-border)] hover:bg-[var(--general-button-bg)] text-[var(--general-button-fg)]`}
                onclkFn={() => setAddressPanel(!addressPanel)}
              />
            </div>

            <div className="w-[220px] shrink-0">
              <SelectField
                containerClass=""
                placeholder="Select Picker"
                label="Picker"
                options={userOptions}
                id="picker_id"
                name="picker_id"
                isSearchable={true}
                errMsgContainerClass="hidden"
                labelWidth="4rem"
                handleSelected={(selectedOption) => {
                  setFieldValue("picker_name", selectedOption?.label ?? "");
                }}
                isDisabled={disabled}
              />
            </div>
          </div>
          {trays && (
            <DocumentTrays
              type="picklist"
              documentId={pickListId}
              trays={trays}
              canEdit={canEditTrays}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default PickListNavbar;
